<span *ngIf="!stravaConnect">
    <a href="https://www.strava.com/oauth/authorize?client_id=44505&response_type=code&scope=activity%3Aread_all&state=TBW&redirect_uri=https%3A%2F%2Fvirtualracesfrance.com%2F%23%2Fstrava%2Fauth"><img [src]="stravaImg" /></a>
</span>
<span *ngIf="stravaConnect">
    <img [src]="stravaImg" />
    <button mat-button color="primary" (click)="unregister()">Click here to unregister</button>
</span>
